import { render } from "./CalculationResults.vue?vue&type=template&id=2f642733&scoped=true"
import script from "./CalculationResults.vue?vue&type=script&lang=js"
export * from "./CalculationResults.vue?vue&type=script&lang=js"

import "./CalculationResults.vue?vue&type=style&index=0&id=2f642733&lang=scss&scoped=true"
import "./CalculationResults.vue?vue&type=style&index=1&id=2f642733&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f642733"]])

export default __exports__